import { useEffect, useState } from 'react';
import type { Box, CustomCategory, CustomRoom, Item, MoveProfile } from '@easymoving/types';
import { useOptionalBackend } from '../lib/backend/context';

export function useItems(): { items: Item[]; loading: boolean } {
  const backend = useOptionalBackend();
  const [items, setItems] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!backend) return;
    setLoading(true);
    return backend.subscribeItems(
      (next) => {
        setItems(next);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, [backend]);
  return { items, loading };
}

export function useBoxes(): { boxes: Box[]; loading: boolean } {
  const backend = useOptionalBackend();
  const [boxes, setBoxes] = useState<Box[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!backend) return;
    setLoading(true);
    return backend.subscribeBoxes(
      (next) => {
        setBoxes(next);
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, [backend]);
  return { boxes, loading };
}

export function useCustomRooms(): CustomRoom[] {
  const backend = useOptionalBackend();
  const [rooms, setRooms] = useState<CustomRoom[]>([]);
  useEffect(() => {
    if (!backend) return;
    return backend.subscribeCustomRooms(setRooms);
  }, [backend]);
  return rooms;
}

export function useCustomCategories(): CustomCategory[] {
  const backend = useOptionalBackend();
  const [categories, setCategories] = useState<CustomCategory[]>([]);
  useEffect(() => {
    if (!backend) return;
    return backend.subscribeCustomCategories(setCategories);
  }, [backend]);
  return categories;
}

export function useMoveProfile(): { profile: MoveProfile | null; loading: boolean } {
  const backend = useOptionalBackend();
  const [profile, setProfile] = useState<MoveProfile | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!backend) return;
    setLoading(true);
    return backend.subscribeMoveProfile((p) => {
      setProfile(p);
      setLoading(false);
    });
  }, [backend]);
  return { profile, loading };
}
